import { Button, Typography } from '@breetometer/components';
import { EmptyWalletAddressIcon } from 'BreetAssets';
import { Loader } from 'BreetComponents';
import { handleApiError, showToast } from 'BreetHelpers';
import { useCountDownTimer } from 'BreetHooks';
import { useGenerateAssetsAddressMutation, useGenerateSingleAssetsAddressMutation } from 'BreetRedux';
import { useCallback } from 'react';

import WalletGenerationCountDown from './components/WalletGenerationCountDown';
import type { IEmptyWalletAddress } from './EmptyWalletAddress.helpers';

const EmptyWalletAddress = ({
	refetchData,
	isFetching,
	title,
	countDownTitle,
	buttonTitle,
	assetId,
	mode,
}: IEmptyWalletAddress) => {
	const [generateAssetsAddress, { isLoading: generateAssetsLoading }] = useGenerateAssetsAddressMutation();
	const [generateSingleAssetsAddress, { isLoading: generateSingleAssetsLoading }] = useGenerateSingleAssetsAddressMutation();

	const COUNTDOWNDURATION = 30;

	const { startCountDownTimer, isCountDownActive } = useCountDownTimer(COUNTDOWNDURATION, assetId);

	const generateAsset = useCallback(() => {
		(mode === 'multiple' ? generateAssetsAddress() : generateSingleAssetsAddress(assetId))
			.unwrap()
			.then(() => {
				showToast('success', `Generating Wallet address${mode === 'multiple' ? 'es' : ''}...`);
				startCountDownTimer();
			})
			.catch(handleApiError);
	}, [assetId, generateAssetsAddress, generateSingleAssetsAddress, mode, startCountDownTimer]);

	if (isFetching) return <Loader />;

	return (
		<>
			{isCountDownActive ? (
				<WalletGenerationCountDown
					startCountdown
					countdownDuration={COUNTDOWNDURATION}
					onCountDownComplete={refetchData}
					countDownId={assetId}
					title={countDownTitle}
				/>
			) : (
				<div className='appassets_emptywallet'>
					<EmptyWalletAddressIcon />

					<Typography
						as='h1'
						className='color-neutral-50'
					>
						{title}
					</Typography>

					<Button
						label={buttonTitle}
						isLoading={generateAssetsLoading || generateSingleAssetsLoading}
						onClick={generateAsset}
						type='button'
					/>
				</div>
			)}
		</>
	);
};

export default EmptyWalletAddress;
